// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"Blog_imageWrapper__2Fqj9","image":"Blog_image__1hqcE"};